import { Stack } from '@ltvco/refresh-lib/theme';
import React from 'react';

import { ContactFooter } from '../ContactFooter/ContactFooter';
import { CreditAnalysisContainer } from '../CreditAnalysis/CreditAnalysisContainer';
import CreditFreeze from '../CreditFreeze/CreditFreeze';
import { CreditScoreHistory } from '../CreditScoreHistory/CreditScoreHistory';
import { ProtectionTools } from '../ProtectionTools/ProtectionTools';

const AuthenticatedContent: React.FC = () => {
  return (
    <Stack direction="column" gap={2.5}>
      <ProtectionTools />
      <CreditScoreHistory />
      <CreditAnalysisContainer />
      <CreditFreeze />
      <ContactFooter />
    </Stack>
  );
};

export default AuthenticatedContent;
